// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._12hzaav0 {
  width: 100%;
}
._12hzaav1 {
  font-size: 15px;
  color: #9b9b9b;
}
apple-pay-button {
  --apple-pay-button-height: 45px;
}
@media screen and (min-width: 768px) {
  ._12hzaav1 {
    font-size: 17px;
    font-weight: 500;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":["._12hzaav0 {\n  width: 100%;\n}\n._12hzaav1 {\n  font-size: 15px;\n  color: #9b9b9b;\n}\napple-pay-button {\n  --apple-pay-button-height: 45px;\n}\n@media screen and (min-width: 768px) {\n  ._12hzaav1 {\n    font-size: 17px;\n    font-weight: 500;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
